import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_VALIDACAO_PERFIL,
  APROVA_VALIDACAO_PERFIL,
  REPROVA_VALIDACAO_PERFIL,
} from 'constants/ActionTypes';
import requisicaoApiCarteirinha from 'util/ApiCarteirinha';
import {
  listaValidacaoPerfilSucesso,
  listaValidacaoPerfilErro,
  aprovaValidacaoPerfilSucesso,
  reprovaValidacaoPerfilSucesso,
  validacaoPerfilErro,
} from 'actions/ValidacaoPerfil';

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getCarteirinhas = async (pagina, tamanhoPagina, status) =>
  await requisicaoApiCarteirinha
    .get(`/v1/carteirinha?status=${status}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`)
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo PATCH ----------------------------------------------------*/

const patchAprovar = async (id, dataExpiracao) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/carteirinha/${id}/aprovar`, dataExpiracao ? { dataExpiracao } : {})
    .then(r => r)
    .catch(e => e);

const patchReprovar = async (id, motivo) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/carteirinha/${id}/reprovar`, { motivo })
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------------- Sagas ----------------------------------------------------------*/

function* listarSaga({ payload }) {
  try {
    const { pagina, tamanhoPagina, status } = payload;
    const result = yield call(getCarteirinhas, pagina, tamanhoPagina, status);
    if (result.response && result.response.status >= 400) {
      yield put(listaValidacaoPerfilErro('Erro ao carregar solicitações.'));
    } else {
      yield put(listaValidacaoPerfilSucesso(result.data));
    }
  } catch (error) {
    yield put(listaValidacaoPerfilErro('Erro ao carregar solicitações.'));
  }
}

function* aprovarSaga({ payload }) {
  try {
    const result = yield call(patchAprovar, payload.id, payload.dataExpiracao);
    if (result.response && result.response.status >= 400) {
      yield put(validacaoPerfilErro('Erro ao aprovar solicitação.'));
    } else {
      yield put(aprovaValidacaoPerfilSucesso());
    }
  } catch (error) {
    yield put(validacaoPerfilErro('Erro ao aprovar solicitação.'));
  }
}

function* reprovarSaga({ payload }) {
  try {
    const result = yield call(patchReprovar, payload.id, payload.motivo);
    if (result.response && result.response.status >= 400) {
      yield put(validacaoPerfilErro('Erro ao reprovar solicitação.'));
    } else {
      yield put(reprovaValidacaoPerfilSucesso());
    }
  } catch (error) {
    yield put(validacaoPerfilErro('Erro ao reprovar solicitação.'));
  }
}

export function* watchListar() {
  yield takeEvery(LISTA_VALIDACAO_PERFIL, listarSaga);
}

export function* watchAprovar() {
  yield takeEvery(APROVA_VALIDACAO_PERFIL, aprovarSaga);
}

export function* watchReprovar() {
  yield takeEvery(REPROVA_VALIDACAO_PERFIL, reprovarSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchListar),
    fork(watchAprovar),
    fork(watchReprovar),
  ]);
}
